/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpindicativeorder_Error3Inputs */

const en_coinvestments_gpindicativeorder_error3 = /** @type {(inputs: Coinvestments_Gpindicativeorder_Error3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update indicative order. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to update indicative order. Please try again." |
*
* @param {Coinvestments_Gpindicativeorder_Error3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpindicativeorder_error3 = /** @type {((inputs?: Coinvestments_Gpindicativeorder_Error3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpindicativeorder_Error3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpindicativeorder_error3(inputs)
});
export { coinvestments_gpindicativeorder_error3 as "coInvestments_gpIndicativeOrder_error" }